import { render } from "./VisitedPeopleManagementView.vue?vue&type=template&id=17c2e23f"
import script from "./VisitedPeopleManagementView.vue?vue&type=script&lang=js"
export * from "./VisitedPeopleManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__